const triggers = document.querySelectorAll('.js-tab-trigger');
const contentList = document.querySelectorAll('.js-tab-content');
const ACTIVE_CLASS = 'is-active';
const SHOW_CLASS = 'is-show';

const removeClass = () => {
  triggers.forEach(trigger => {
    trigger.classList.remove(ACTIVE_CLASS);
  });

  contentList.forEach(content => {
    content.classList.remove(SHOW_CLASS);
  });
};

const clickHandler = (e) => {

  const trigger = e.currentTarget;

  if (trigger.classList.contains(ACTIVE_CLASS)) return;

  removeClass();

  trigger.classList.add(ACTIVE_CLASS);

  const target = document.querySelector(`#${trigger.dataset.target}`);

  target.classList.add(SHOW_CLASS);

};

const init = () => {
  if (triggers.length === 0) return;

  triggers.forEach(trigger => {
    trigger.addEventListener('click', clickHandler);
  });
};

export default init;
